import React, { useEffect, useState, useRef } from 'react';
import useWindowSize from '../../../../hooks/useWindowSize';

import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { isEmpty } from 'lodash';
import queryString from 'query-string';

import SiteContextMenu from './SiteContextMenu';
import BobLoadingMask from '../../../../components/BobLoadingMask';
import DeleteCoreEntityModal from '../../Modals/DeleteCoreEntityModal';
import PreviewWeatherDataModal from '../../Modals/PreviewWeatherDataModal';

import { process as kendoProcess } from '@progress/kendo-data-query';
import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { calculateMinColumnWidths } from '../../../../helpers/calculateMinColumnWidths';

import * as K2ACoreActions from '../../../../actions/k2aCoreActions';
import * as TableActions from '../../../../actions/tableActions';
import * as BobActions from '../../../../actions/bobActions';
import { kendoGridInlineStyling } from '../../../../helpers/kendoGridInlineStyleHelper';
import * as classes from '../EntitiesPage.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const CoreSiteTable = ({
    activeNavCompany,
    activeNavClient,
    bobLoading,
    deleteCoreSite,
    fetchClient,
    history,
    sites,
    sitesMeta,
    fetchCoreSites,
    fetchCoreSitesByClient,
    fetchNavSites,
    fetchNavEquipment,
    navClients,
    refreshTab,
    setRefreshTab,
    searchTerm,
    setCoreSite,
    setActiveNavClient,
    setActiveNavSite,
    setNavClient,
    tableProps,
    updateTableProps,
    view,
    workbookModeEnabled,
    ...props
}) => {

    const [dataState, setDataState] = useState(initialDataState);
    const [deleteSiteModalOpen, setDeleteSiteModalOpen] = useState(false);
    const [selectedSite, setSelectedSite] = useState({});
    const [pageable] = useState({ pageSizes: true });
    const [selectedSites, setSelectedSites] = useState([]);
    const [tableState, setTableState] = useState('');
    const [siteNameColumnWidth, setSiteNameColumnWidth] = useState(450);
    const [take, setTake] = useState(10);
    const [previewWeatherDataModalOpen, setPreviewWeatherDataModalOpen] = useState(false);
    const [site, setSite] = useState(null);

    const queryValues = queryString.parse(history.location.search);

    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setSiteNameColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'name', 450, true));
    }, [windowSize]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        const init = async () => {
            if (queryValues.childId === '7d2489e6-4481-481a-8fbf-d5c0262c6539' && (tableState !== 'company' && (sitesMeta.entity && sitesMeta.entity !== 'company'))) {
                await fetchCoreSites(activeNavCompany.id, { page: 1, limit: dataState.take });
            } else if (queryValues.childId === 'e979b520-3695-422d-a914-ba55c51fb316' && activeNavClient.id && (tableState !== 'client' && (sitesMeta.entity && sitesMeta.entity !== 'client'))) {
                await fetchCoreSitesByClient(activeNavClient.id, { page: 1, limit: dataState.take });
            }
        };

        if (activeNavCompany.id) init();
    }, [queryValues.childId]);

    useEffect(() => {
        const init = async () => {
            await fetchCoreSitesByClient(activeNavClient.id, { page: 1, limit: dataState.take });
        };

        if (activeNavClient.id && sitesMeta.isActive && sitesMeta.client !== activeNavClient.id) init();
    }, [activeNavClient]);

    useEffect(() => {
        const init = async () => {
            if (queryValues.childId === '7d2489e6-4481-481a-8fbf-d5c0262c6539') {
                await fetchCoreSites(activeNavCompany.id, { page: 1, limit: dataState.take });
                setTableState('company');
            }
        };

        if (activeNavCompany.id && (!sitesMeta.isActive || sitesMeta.company !== activeNavCompany.id)) init();
    }, [activeNavCompany]);

    useEffect(() => {
        const init = async () => {
            if (queryValues.childId === 'e979b520-3695-422d-a914-ba55c51fb316' && tableState !== 'client') {
                await fetchCoreSitesByClient(activeNavClient.id, { page: 1, limit: dataState.take });
                setTableState('client');
            }
        };

        if (activeNavClient.id && !sitesMeta.isActive) init();
    }, [activeNavClient]);

    useEffect(() => {
        if (tableProps.coreSite) {
            let updatedDataState = { ...dataState };
            updatedDataState.skip = (tableProps.coreSite.page * tableProps.coreSite.limit) - tableProps.coreSite.limit;
            updatedDataState.take = tableProps.coreSite.limit;
            setDataState(updatedDataState);
        }
    }, [tableProps]);

    useEffect(() => {
        setSelectedSites(sites);
    }, [sites]);

    useEffect(() => {
        setSelectedSites(sites.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase())));
    }, [searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            setRefreshTab(view);
            if (view === 'Company Site') {
                await fetchCoreSites(activeNavCompany.id, { page: 1, limit: dataState.take });
            } else if ( view === 'Client Site') {
                await fetchCoreSitesByClient(activeNavClient.id, { page: 1, limit: dataState.take });
            }

            if (searchTerm) {
                setSelectedSites(sites.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase())));
            }

            setRefreshTab('');
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <SiteContextMenu
                    dataItem={props.dataItem}
                    setCoreSite={setCoreSite}
                    setDeleteSiteModalOpen={setDeleteSiteModalOpen}
                    setSelectedSite={setSelectedSite}
                    onPreviewWeatherData={(entityData) => handlePreviewWeatherData(props.dataItem)}
                />
            </td>
        );
    };

    const renderBuildingTypeCell = props => {
        const buildingType = props.dataItem.buildingType.name;

        return (
            <td>
                {buildingType}
            </td>
        );
    };

    const renderAddressCell = props => {
        const streetNumber = props.dataItem.address ? props.dataItem.address.streetNumber : '';
        const route = props.dataItem.address ? props.dataItem.address.route : '';

        return (
            <td>
                {`${streetNumber} ${route}`}
            </td>
        );
    };

    const renderCityCell = props => {
        const city = props.dataItem.address ? props.dataItem.address.locality : '';

        return (
            <td>
                {city}
            </td>
        );
    };

    const renderStateCell = props => {
        const state = props.dataItem.address ? props.dataItem.address.administrativeAreaLevel1 : '';

        return (
            <td>
                {state}
            </td>
        );
    };

    const renderZipCell = props => {
        const zip = props.dataItem.address ? props.dataItem.address.postalCode : '';

        return (
            <td>
                {zip}
            </td>
        );
    };

    const renderCampusCell = props => {
        return (
            <td>
                {props.dataItem.campus.name}
            </td>
        );
    };

    const renderUnitOfMeasureCell = props => {
        const unitOfMeasure = props.dataItem.squareAreaUOM;
        const formattedUnit = unitOfMeasure.match(/[A-Z][a-z]+/g).join(' ');
        return (
            <td>
                {formattedUnit}
            </td>
        );
    };

    const handleDeleteSite = async () => {
        await deleteCoreSite(selectedSite.id);

        if (queryValues.childId === '7d2489e6-4481-481a-8fbf-d5c0262c6539') {
            await fetchCoreSites(activeNavCompany.id, { page: 1, limit: dataState.take, searchFilter: searchTerm });
        } else {
            await fetchCoreSitesByClient(activeNavClient.id, { page: 1, limit: dataState.take, searchFilter: searchTerm });
        }
    };

    const handleNameNavigation = dataItem => {
        let path = '/v2/dashboard/core/entities';

        const queryValues = queryString.parse(history.location.search);
        queryValues.parentId = '33ba6af0-1e7a-4fcf-b75b-f355a01a962b';
        queryValues.childId = '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd';
        queryValues.client = dataItem.client.id;
        queryValues.site = dataItem.id;

        const queryValuesString = queryString.stringify(queryValues);
        return (`${path}?${queryValuesString}`);
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/core/entities';
        
        const queryValues = queryString.parse(history.location.search);
        queryValues.parentId = '33ba6af0-1e7a-4fcf-b75b-f355a01a962b';
        queryValues.childId= '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd';
        queryValues.client = dataItem.client.id;
        queryValues.site = dataItem.id;

        let navClient = navClients.filter(client => client.id === dataItem.client.id);
        let client;
        
        if (!navClient.isEmpty && navClient.length !== 0) {
            client = {
                id:   dataItem.client.id,
                name: navClient[0].name
            };
        } 
        
        const site = {
            id:   dataItem.id,
            name: dataItem.name
        };

        setNavClient(client);
        setActiveNavClient(client);
        setActiveNavSite(site);
        await fetchNavSites(dataItem.client.id);
        await fetchNavEquipment(dataItem.id);

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <Link
                    to={handleNameNavigation(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const handlePreviewWeatherData = siteData => {
        setSite(siteData);
        setPreviewWeatherDataModalOpen(true);
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef}
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(selectedSites, dataState)}
                    {...dataState}
                    onDataStateChange={onDataStateChange}
                    filterable={workbookModeEnabled}
                    pageable={pageable}
                    reorderable
                >
                    {

                        bobLoading.includes('FetchCoreSites') || isEmpty(sitesMeta) ?
                            <GridNoRecords>
                                Loading sites
                            </GridNoRecords>
                            :
                            null
                    }
                    <Column
                        field="name"
                        title={'Site'}
                        cell={nameCell}
                        id={'siteColumn'}
                        width={siteNameColumnWidth}
                    />
                    <Column
                        field="buildingType.name"
                        title="Building Type"
                        width={275}
                        cell={renderBuildingTypeCell}
                    />
                    <Column
                        field="squareFootage"
                        title="Area"
                        width={150}
                    />
                    <Column
                        field="squareAreaUOM"
                        title="Unit of Measure"
                        width={175}
                        cell={renderUnitOfMeasureCell}
                    />
                    <Column
                        field="address.formattedAddress"
                        title="Address"
                        cell={renderAddressCell}
                        id={'addessColumn'}
                        width={300}
                    />
                    <Column
                        field="address.locality"
                        title="City"
                        width={150}
                        cell={renderCityCell}
                    />
                    <Column
                        field="address.administrativeAreaLevel1"
                        title="State"
                        width={150}
                        cell={renderStateCell}
                    />
                    <Column
                        field="address.postalCode"
                        title="Zip"
                        width={150}
                        cell={renderZipCell}
                    />
                    <Column
                        field="campus.name"
                        title="Campus"
                        width={150}
                        cell={renderCampusCell}
                    />
                    <Column
                        field="timeZone"
                        title="Time Zone"
                        width={150}
                    />
                    <Column
                        field=""
                        title=""
                        locked={true}
                        sortable={false}
                        filterable={false}
                        width={80}
                        cell={actionsCell}
                    />
                </Grid>
                {
                    deleteSiteModalOpen ?
                        <DeleteCoreEntityModal
                            entity={{ ...selectedSite, type: 'Site' }}
                            handleDeleteEntity={handleDeleteSite}
                            toggleModalOpen={setDeleteSiteModalOpen}
                        />
                        :
                        null
                }
                {
                    bobLoading.includes('FetchCoreSites') || isEmpty(sitesMeta) ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
            {
                previewWeatherDataModalOpen ?
                    <PreviewWeatherDataModal
                        site={{name: site.siteName, id: site.id}}
                        onClose={() => setPreviewWeatherDataModalOpen(false)}
                    />
                    :
                    null
            }
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    activeNavClient:  state.bob.activeNavClient,
    bobLoading:       state.bob.bobLoading,
    navClients:       state.bob.navClients,
    sites:            state.k2aCore.sites,
    sitesMeta:        state.k2aCore.sitesMeta,
    tableProps:       state.tableProps
});

const mapDispatchToProps = ({
    ...K2ACoreActions,
    ...TableActions,
    ...BobActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CoreSiteTable));
